import React from 'react';
import Nav from '../components/layout/Nav';
import Footer from '../components/layout/Footer';
import '../styles/about.scss';
import { Col, Row, Container, Carousel } from 'react-bootstrap';
// import Image1 from '../assets/other/about-thumb-list1.webp';
import Image1 from '../assets/other/about-thumb-list1.webp';

import Image2 from '../assets/other/about-thumb-list2.webp';
import TestimonialSection from '../components/Testimonials';
import Metrics from '../components/Metrics';
import WhoWeAre from '../components/WhoWeAre';

const About = () => {
  // Core values data
  const coreValues = [
    {
      icon: '👑',
      title: 'Dignity',
      description: 'Honoring the craft and worth of every artisan we work with',
    },
    {
      icon: '🤝',
      title: 'Trust',
      description:
        'Building reliable, transparent connections between artisans and clients',
    },
    {
      icon: '⭐',
      title: 'Excellence',
      description:
        'Delivering exceptional quality in every project and interaction',
    },
    {
      icon: '💡',
      title: 'Innovation',
      description:
        'Leveraging technology to transform and elevate craftsmanship',
    },
    {
      icon: '❤️',
      title: 'Empathy',
      description:
        'Understanding and addressing the unique needs of artisans and clients',
    },
    {
      icon: '🚀',
      title: 'Empowerment',
      description:
        'Equipping artisans with tools and opportunities to reach their full potential',
    },
  ];

  return (
    <>
      <Nav />
      <section className="about-page-hero">
        <div className="about-page-hero-content">
          <h1>About Us</h1>
          <h6>
            <p>
              <a href="/">Home</a> -{' '}
            </p>{' '}
            About us
          </h6>
        </div>
      </section>
      <WhoWeAre />

      {/* Vision, Mission & Values Section */}
      <section className="vision-mission-section">
        <Container>
          {/* ---------- Header ---------- */}
          <div className="section-header">
            <span className="section-eyebrow">
              <span className="section-eyebrow-dot" />
              What drives us
            </span>

            <h2 className="section-title">
              Our vision, mission & <em>values</em>
            </h2>

            <p className="tagline">
              Empowering Kenya's makers, inspiring the world
            </p>

            <p className="section-subtitle">
              Driving craftsmanship into the future through technology and
              empowerment
            </p>
          </div>

          {/* ---------- Cards ---------- */}
          <Row className="strategy-cards-row">
            {/* Vision */}
            <Col lg={4} className="mb-4">
              <div className="strategy-card vision-card">
                <div className="card-icon">
                  <div className="icon-wrapper">
                    <span className="icon">🌍</span>
                  </div>
                </div>
                <div className="card-content">
                  <span className="card-label">Our Vision</span>
                  <h3>Building Africa's digital craftsmanship hub</h3>
                  <p className="card-description">
                    To build Africa's most trusted digital ecosystem that
                    connects and dignifies artisans while transforming how the
                    world experiences craftsmanship.
                  </p>
                  <div className="card-highlight vision">
                    <span>Africa's #1 craftsmanship hub</span>
                  </div>
                </div>
              </div>
            </Col>

            {/* Mission */}
            <Col lg={4} className="mb-4">
              <div className="strategy-card mission-card">
                <div className="card-icon">
                  <div className="icon-wrapper">
                    <span className="icon">⚡</span>
                  </div>
                </div>
                <div className="card-content">
                  <span className="card-label">Our Mission</span>
                  <h3>Empowering artisans, connecting communities</h3>
                  <p className="card-description">
                    To empower skilled makers through technology, visibility,
                    and fair opportunity, bridging them to clients locally and
                    globally.
                  </p>
                  <div className="card-highlight mission">
                    <span>Locally crafted, globally seen</span>
                  </div>
                </div>
              </div>
            </Col>

            {/* Values — rotating carousel */}
            <Col lg={4} className="mb-4">
              <div className="strategy-card values-card">
                <Carousel
                  indicators={true}
                  controls={false}
                  interval={3000}
                  pause={false}
                  className="values-inner-carousel"
                >
                  {coreValues.map((value, index) => (
                    <Carousel.Item key={index}>
                      <div className="card-icon">
                        <div className="icon-wrapper">
                          <span className="icon">{value.icon}</span>
                        </div>
                      </div>
                      <div className="card-content">
                        <span className="card-label">Our Values</span>
                        <h3>{value.title}</h3>
                        <p className="card-description">{value.description}</p>
                        <div className="card-highlight values">
                          <span>
                            Value {String(index + 1).padStart(2, '0')} of 06
                          </span>
                        </div>
                      </div>
                    </Carousel.Item>
                  ))}
                </Carousel>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

    <section className="about-page-info" id="why-choose-us">
  <div className="about-page-info-inner">
    <Row className="about-page-info-content">
      {/* ---------- LEFT — image stack ---------- */}
      <Col md={6} className="about-page-info-images">
        <div className="about-image-stack">
          <div className="image-large">
            <img src={Image1} alt="About Artiza — workshop" />
          </div>
          <div className="image-small">
            <img src={Image2} alt="Finished artisan work" />
          </div>

          {/* Floating badge */}
          <div className="about-image-badge">
            <span className="about-image-badge-value">100%</span>
            <span className="about-image-badge-label">Handcrafted</span>
          </div>
        </div>
      </Col>

      {/* ---------- RIGHT — text ---------- */}
      <Col md={6} className="about-page-info-text">
        <span className="info-eyebrow">Why choose us</span>

        <h2 className="info-heading">
          Direct from artisans,
          <br />
          straight to <em>you</em>.
        </h2>

        <p className="info-lead">
          Artiza is where Kenya's craftsmanship meets technology and trust.
          We connect you directly with verified artisans — from furniture
          makers to electricians — who deliver quality, creativity, and
          reliability in every project.
        </p>

        <p className="info-body">
          By empowering local makers with fair pay, digital visibility, and
          smart tools like AI and AR, Artiza ensures a transparent, modern,
          and human experience for both artisans and clients. Choose Artiza
          — where every masterpiece has a maker and every maker has a story.
        </p>

        {/* Small feature pills */}
        <ul className="info-highlights">
          <li>
            <span className="highlight-dot" />
            Verified makers only
          </li>
          <li>
            <span className="highlight-dot" />
            Fair, transparent pay
          </li>
          <li>
            <span className="highlight-dot" />
            AI & AR assisted
          </li>
        </ul>
      </Col>
    </Row>
  </div>
</section>

      <Metrics />
      <TestimonialSection />

      {/* <div className="partners">
        <img src={Partner1} alt="partner 1" />
        <img src={Partner2} alt="partner 2" />
        <img src={Partner3} alt="partner 3" />
        <img src={Partner4} alt="partner 4" />
        <img src={Partner5} alt="partner 5" />
      </div> */}

      <Footer />
    </>
  );
};

export default About;
